module.exports = {
      id: "icon-facebook-usage",
      viewBox: "0 0 13.521 25.459",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-facebook",
      toString: function () {
        return this.url;
      }
    }